import React, { ReactNode } from 'react';
import { RightAngleIcon } from '../../../../components/Icons/RightAngle';

import './PaymentMethod.css';

type PaymentMethodProps = {
  isPostePay?: boolean;
  description?: string;
  onClick?: () => void;
  images: ReactNode[];
};

export const PaymentMethod: React.FC<PaymentMethodProps> = ({
  description,
  images,
  isPostePay,
  onClick,
}) => {
  return (
    <div
      role="link"
      onClick={onClick}
      className={`payment-method--container ${
        isPostePay ? 'payment-method--primary' : ''
      } ${!onClick ? 'payment-method--disabled' : ''}`}
    >
      <div className="payment-method--description-container">
        {description && (
          <p className="payment-method--description">{description}</p>
        )}
        <div className="payment-method--images-container">
          {images.map((img, i) => {
            return (
              <React.Fragment key={i}>
                <div className="payment-method--image">{img}</div>
              </React.Fragment>
            );
          })}
        </div>
      </div>
      <div className="payment-method--arrow-container">
        <RightAngleIcon color={'var(--color-over-primary)'} />
      </div>
    </div>
  );
};
